import COLOR_THEMES from "./colorThemes";
import $ from "jquery";
import {hardCodeIsPorcelanosa, hardCodeIsRenuit} from "../../../../../misc/fabricatorHardcode";
import {SQFT_AR3D_GLB_VIEWER} from "../../../constants";

export const MIN_DISTANCE_BETWEEN_FREE_DRAW_POINTS = 4

class SqftConfig {
  constructor() {
    // Initialization of properties
    this.ctx = null;
    this.measureUnit = "Imperial";
    this.mmDivider = 1000;
    this.mm2ToM2Divider = 1000000;
    this.millimetersMultiplier = 25.4;
    this.inchesToMMultiplier = 1 / 39.37;
    this.sqftToMmMultiplier = 92903;
    this.sqftToM2Multiplier = 1 / 10.764;
    this.lnftToMmMultiplier = 304.8;
    this.waterfallImperialHeight = 36;
    this.waterfallMetricHeight = 900;
    this.miteredEdgeAdditionalImperialArea = hardCodeIsPorcelanosa() ? 1.5 : 1.5;
    this.miteredEdgeAdditionalMetricArea = 0; //40;//38.1;
    this.edgeHeightImperial = 1.25;
    this.edgeHeightMetric = 30;
    this.minApplianceLineLength = 1;
    this.maxApplianceLineLength = 150;
    this.slab = {
      imageWidthMetric: 3200,
      imageHeightMetric: 1600,
      imageWidthImperial: 120,
      imageHeightImperial: 60
    };
    this.workspace = {
      canvas: $('#workspace'),
      gridSize: 12,
      getScaledGridSize: () => this.getScaledGridSize(this.workspace.gridSize),
      getDefaultScaledGridSize: () => this.getScaledGridSize(this.workspace.gridSize, true),
      fontSize: $(window).width() <= 1024 ? 14 : 16,
      fontSizeMetric: $(window).width() <= 1024 ? 14 : 16,
      fontSizeSmallest: $(window).width() <= 1024 ? 11 : 11,
      debug: false,
      snapToGrid: false,
      menuItemActive: null,
      snapToAngles: true,
      snapAngleSte: 45,
      snapAngleEps: 5,
    };
    this.defaultScaleExport = 7;
    this.zoomSpeed = 5;
    this.controls = {
      scale: $('#scale-control'),
      scaleHoriz: $('#scale-control-horiz'),
      snapToGrid: $('#snapToGrid'),
      debug: $('#debug'),
      delete: $('#delete'),
      flipH: $('#flipH'),
      flipV: $('#flipV'),
      rotateLeft: $('#rotateLeft'),
      rotateRight: $('#rotateRight')
    };
    this.activeClass = 'active';
    this.activePalletItemClass = "pallet-tool-icon-selected";
    this.groups = {
      tools: "tools"
    };
    this.filterGroups = [];
    this.tutorialIsRunning = false;
    this.highlight = {
      points: false,
      lines: false,
      linesWithShapePartIds: [],
      type: '',
      id: null,
      demoShow: false,
      rotateAngle: false,
    };
    this.activeTheme = Object.keys(COLOR_THEMES)[0];
    this.SNAP_OFFSET = 12;
    this.activeFontRegular = "playregular";
    this.activeFontBold = "playbold";
    this.crownMoldingParams = {
      distance: 10
    };
    this.threeD = {
      //glbViewer: SQFT_AR3D_GLB_VIEWER.singleModel,
      glbViewer: SQFT_AR3D_GLB_VIEWER.separateModels,
      useGoogleModelViewer: false, // this requires singleModel
      useStagingDomain: false,
      //useStagingDomain: true,
    }
    this.shouldUseCabinetDoorsSQFT = hardCodeIsRenuit();
    this.shouldUseCabinetDoorsLNFT = false;
    this.shouldUseCabinetDoorsAndDrawersQuantity = false;
    this.shouldAddCabinetBoxes = false;

    // Initialize dependent properties
    this.initializeDependentProperties();

    // Add event listeners
    document.addEventListener('DOMContentLoaded', this.initialize);
    window.addEventListener('resize', this.updateDimensions);
  }

  initializeDependentProperties = () => {
    this.fieldWidth = this.getMM() * 13;
    this.fieldWidthCabinet = 4;
    this.updateDimensions();
    this.updateDefaultScale();
    this.setScale(this.defaultScale);
  }

  setScale = (scale) => {
    this.scale = scale;
  }
  getMM = () => {
    const getDPI = () => {
      const div = document.createElement('div');
      div.style.height = '1in';
      const body = document.getElementsByTagName('body')[0];
      body.appendChild(div);
      const dpi = div.offsetHeight;
      body.removeChild(div);
      return dpi === 0 ? 96 : dpi;
    }
    return getDPI() / 25.4;
  }

  isKiosk = (() => {
    let isKiosk = false;
    try {
      isKiosk = (parent && parent.parent && parent.parent.window.app && parent.parent.window.app.db);
    } catch (e) {
      isKiosk = false;
    }
    return isKiosk;
  })();

  kioskApp = (() => {
    if (this.isKiosk) {
      return parent.parent.window.app;
    }
  })();

  initialize = () => {
    this.updateDimensions();
    this.initializeDependentProperties();
  }

  updateDimensions = () => {
    this.updateDefaultScale();
    this.updateWorkspace(window.innerWidth);
  }

  updateDefaultScale = () => {
    this.defaultScale = window.innerWidth <= 1024 ? 1.5 : 3.75;
  };

  updateWorkspace = (windowWidth) => {
    this.workspace.fontSize = windowWidth <= 1024 ? 14 : 16;
    this.workspace.fontSizeMetric = windowWidth <= 1024 ? 14 : 16;
    this.workspace.fontSizeSmallest = windowWidth <= 1024 ? 11 : 11;
  }

  getMeasureMultiplier = () => {
    switch (this.measureUnit) {
      case "Metric":
        return this.millimetersMultiplier;
      case "Metric-meters":
        return 1 / 39.37;
      case "Imperial":
      default:
        return 1;
    }
  }

  getMeasureUnitPostfix = (shouldAddWhitespace = false) => {
    switch (this.measureUnit) {
      case "Metric":
        return shouldAddWhitespace ? " mm" : "mm";
      case "Imperial":
      default:
        return "\"";
    }
  }

  isDevMode = () => window.location.href.includes("dev=1");

  isLocalComposerMode = () => !!document.kvConfig.useLocalComposer;

  isCabinetGroupInURL = () => window.location.href.includes("group=cabinets");

  isAreaGroupInURL = () => window.location.href.includes("group=area");

  isSQFTEnabledInURL = () => window.location.hash.includes("sqft");

  getScaledGridSize = (gridSize, isDefault = false) => {
    const scale = isDefault ? this.defaultScale : this.scale;
    let scaledGridSize = Math.round(gridSize / scale);
    let nearest = (12 % scaledGridSize);
    return nearest < scaledGridSize / 2 ?
      scaledGridSize - nearest :
      scaledGridSize + nearest;
  }
}

export default new SqftConfig();
